module.exports = __webpack_public_path__ + "img/crew_adv_09.35f214ea.png";